import React from 'react';

/**
 * ONE look for every bar that pins to the top while the page scrolls under it
 * (Signal Analysis' jump bar, Best Trades' highlight panel) — Apal
 * 2026-10-04: the panel must never be "confused with background" on the dark
 * theme; "signal analysis also has a filter like thats sticky, we gotta do
 * same".
 *
 * - its own surface, one clear step lighter than the #1e293b cards, with a
 *   blue edge — so it reads as a control panel, pinned or not
 * - pinned: a blue bottom rule, a deep shadow and a fade beneath, so the
 *   content visibly slides UNDER it
 * - no layout change on pinning: the top border turns transparent (removing
 *   it made the panel 1px shorter and nudged the content on every pin) and
 *   the blue rule is an inset shadow, not a thicker border
 */
export const PANEL_BG = '#2b3a57';

export const panelClass = (pinned) => `border ${pinned
  ? 'border-primary-400/50 border-t-transparent rounded-b-xl shadow-[inset_0_-3px_0_#3b82f6,0_18px_40px_-4px_rgba(0,0,0,0.9)]'
  : 'border-primary-400/50 rounded-xl shadow-lg shadow-black/40'}`;

/** The dark fade under a pinned panel. Render inside the panel. */
export const PinnedFade = ({ show }) => (show
  ? <div aria-hidden className="pointer-events-none absolute left-0 right-0 top-full h-10 bg-gradient-to-b from-dark-900/90 to-transparent" />
  : null);
